import React from "react";
import Select from 'react-select';
import storage from "../../Firebase/index";
import {RotateCircleLoading} from 'react-loadingg';

import {MdDelete} from 'react-icons/md';
import ClassTableRow from "../../components/Tables/ClassTableRow";
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Modal,
    Row,
    Table
} from "reactstrap";
// core components
import {Redirect} from "react-router-dom";
import constants from "../../shared/constants";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import ErrorModal from "../../components/Alerts/ErrorModal";
import businessHelper from "../../helpers/BusinessHelper";
import ResourceApiService from "../../api/resource-api-service";
import TeacherHeader from "../../components/Headers/TeacherHeader";
import LoadingOverlay from "react-loading-overlay";
import ReactTooltip from "react-tooltip";
import dateHelpers from "../../helpers/DateHelper";
import SalaryEditor from "../../components/Resources/SalaryEditor";
import ProBadge from "../../components/Alerts/ProBadge";
import subscriptionHelpers from "../../helpers/SubscriptionHelper";
import NotProModal from "../../components/Alerts/NotProModal";
import numberHelpers from "../../helpers/NumberHelper";

let studentStrings = new LocalizedStrings(student_strings);
let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

class Teacher extends React.Component {

    constructor(props) {
        super(props);

        this.fileRef = React.createRef();

        this.state = {
            business: businessHelper.business(),
            showClasses: false,
            selectedMonth: null,
            teacherId: props.location.state.teacherId,
            backToClassId: props.location.state ? props.location.state.backToClassId : null,
            backToClassName: props.location.state ? props.location.state.backToClassName : null,
            salaryForSelectedMonth: null,
            teacher: null,
            selectedDate: new Date(),
            isLoading: true,
            profileWasUpdated: false,
            file: null,
            blob: null,
            backToProfile: false,
            selectedFile: null,
            photoLoading: false,
            formData: {},
            showError: false,
            error: null,
            classTypes: null,
            showSalaryEditor: false,
            showNotProModal: false,
            isTeacherSession: businessHelper.isTeacherSession(),
            validation: {
                name: true,
                email: true,
                day: true
            }
        };
    }

    handleSubmit = this.handleSubmit.bind(this);
    handleChange = this.handleChange.bind(this);
    goToClass = this.goToClass.bind(this);
    handleNetworkError = this.handleNetworkError.bind(this);
    showClasses = this.showClasses.bind(this);
    getTeacherSalary = this.getTeacherSalary.bind(this);
    showNextMonth = this.showNextMonth.bind(this);
    showPrevMonth = this.showPrevMonth.bind(this);
    editSalary = this.editSalary.bind(this);
    sendEmail = this.sendEmail.bind(this);

    sendEmail() {
        if (this.state.teacher.email && this.state.teacher.email.length > 0 && this.state.teacher.email.includes("@")) {
            window.location.href = `mailto:${this.state.teacher.email}`;
        }
    }

    showClasses(e) {
        e.preventDefault();

        this.setState({
            showTickets: false,
            showTicketTypeSelector: false,
            showClasses: true,
            showTicketEditor: false,
        })
    }

    handleClick(e) {
        this.fileRef.current.click();
    }

    showEditTeacher(e) {
        e.preventDefault();

        this.setState({
            showSalaryEditor: false,
        })
    }

    handleMonthSelected = selectedOption => {
        this.updateBd(null, selectedOption.value);

        this.setState({
                selectedMonth: selectedOption,
                profileWasUpdated: true
            }
        )
    };

    getTeacher(id = this.state.teacherId || this.state.teacher.id) {
        ResourceApiService.teacher(id)
            .then(res => {
                this.setState({
                    teacher: res,
                    yclasses: res.classes,
                    bd: res.bd
                });

                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        name: res.name,
                        email: res.email,
                        phone: res.phone,
                        note: res.note,
                        address: res.address,
                        dni: res.dni,
                        bd: res.bd,
                        pm: res.pm,
                        bio: res.bio,
                    }
                }));

                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    updateTeacher(teacherId = this.state.teacher.id) {

        const teacherData = {
            id: teacherId,
            name: this.state.formData.name,
            phone: this.state.formData.phone,
            dni: this.state.formData.dni,
            bd: this.state.bd,
            bank: this.state.formData.bank,
            address: this.state.formData.address,
            email: this.state.formData.email,
            note: this.state.formData.note,
            public: this.state.teacher.public,
            bio: this.state.formData.bio,
        };

        ResourceApiService.updateTeacher(teacherData)
            .then(res => {
                this.getTeacher()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });

        this.setState({
            profileWasUpdated: false,
        });
    }

    renderTableData() {
        return this.state.yclasses.map((yclass, index) => {
            return (
                <ClassTableRow yclass={yclass} key={yclass.id} goToClass={this.goToClass} showTicketInfo={false}
                               showStudentsCount={true}/>
            )
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.formData !== this.state.formData) {
            this.handleValidation();
        }
    }

    componentDidMount() {
        if (!localStorage.getItem(constants.open.AUTH_TOKEN) || !localStorage.getItem(constants.open.BUSINESS)) {
            return <Redirect from="*" to="/auth/login"/>
        }

        if (this.state.teacherId) {
            this.getTeacher();
            this.getTeacherSalary()
        }

        this.tableRef = React.createRef();
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (this.state.teacherId !== nextState.teacherId) {
            this.getTeacher(nextState.teacherId)
        }
    }

    getBdDay() {
        let bd = this.state.bd;
        if (bd) {
            if (bd.includes("|")) {
                return bd.split('|')[0];
            } else {
                return "0"
            }
        }
    }

    getBdMonth(b = null) {
        let bd = b ? b : this.state.bd;
        if (bd) {
            if (bd.includes("|")) {
                let m = bd.split('|')[1];

                let index = constants.months.map(function (o) {
                    return o.value;
                }).indexOf(m);

                if (index !== null) {
                    return constants.months[index]
                } else {
                    return null
                }
            } else {
                return null
            }
        }
    }

    handleChange(event) {
        this.setState({
            profileWasUpdated: true,
        });

        let newValue = event.target.value;
        let targetId = event.target.id;
        let cbValue = event.target.checked;

        switch (targetId) {
            case "input-name":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        name: newValue
                    }
                }));
                break;
            case "input-id-number":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        dni: newValue
                    }
                }));
                break;
            case "input-email":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        email: newValue
                    }
                }));
                break;
            case "input-phone":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        phone: newValue
                    }
                }));
                break;
            case "input-address":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        address: newValue
                    }
                }));
                break;
            case "input-note":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        note: newValue
                    }
                }));
                break;
            case "input-bio":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        bio: newValue
                    },
                    teacher: {
                        ...prevState.teacher,
                        bio: cbValue
                    }
                }));
                break;
            case "input-public-cb":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        public: cbValue
                    },
                    teacher: {
                        ...prevState.teacher,
                        public: cbValue
                    }
                }));
                break;
            case "input-bd-day":
                this.updateBd(newValue, null);
                break;
            case "input-pm":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        bank: newValue
                    }
                }));
                break;
            default:
                return
        }
    }

    updateBd(day = null, month = null) {
        this.validateDay(day);

        let bd = this.state.bd ? this.state.bd : "";
        if (day !== null) {
            if (bd.includes("|")) {
                month = bd.split("|")[1];
            } else {
                month = 1
            }
        } else {
            if (bd.includes("|")) {
                day = bd.split("|")[0];
            } else {
                day = 1
            }
        }

        bd = day + "|" + month;

        this.setState({
            bd: bd
        })
    }

    onChangeFile(event) {
        this.setState({
            photoLoading: true,
        });
        event.stopPropagation();
        event.preventDefault();
        var file = event.target.files[0];
        console.log(file);
        const blob = URL.createObjectURL(event.target.files[0]);
        // this.setState({
        //     blob: blob
        // });
        this.setState({file}); /// if you want to upload latter
        this.uploadFile(file);
    }

    uploadFile(file) {
        const businessId = JSON.parse(localStorage.getItem(constants.open.BUSINESS)).id;
        const uploadTask = storage.ref(`teachers/${businessId}/teacher_${this.state.teacher.id || this.state.teacherId}`).put(file);
        uploadTask.on(
            "state_changed",
            snapshot => {
                // progress function ...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                this.setState({progress});
            },
            error => {
                // Error function ...
                this.setState({
                    photoLoading: true,
                });
                console.log(error);
            },
            () => {
                // complete function ...
                storage
                    .ref(`teachers/${businessId}`)
                    .child(`teacher_${this.state.teacher.id || this.state.teacherId}`)
                    .getDownloadURL()
                    .then(url => {
                        this.setState({url});
                        this.updateTeacherPhoto(url);
                    });
            }
        );
    };

    updateTeacherPhoto(url) {
        ResourceApiService.updateTeacher({id: this.state.teacher.id, photo: url})
            .then(res => {
                this.setState({photoLoading: false});
                this.getTeacher()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleSubmit(event) {
        event.preventDefault();

        if (this.state.teacher !== null) {
            this.updateTeacher(this.state.teacher.id);
        } else {
            this.postTeacher();
        }
    }

    render() {
        this.localize();

        if (this.state.goToClass === true && this.state.goToClassId) {
            return <Redirect from="*" to={{
                pathname: "/admin/class_overview",
                state: {yclassId: this.state.goToClassId}
            }}/>
        }

        if (this.state.backToProfile === true) {
            return <Redirect from="*" to={{
                pathname: "/admin/user-profile",
                state: {
                    showTeachers: true
                }
            }}/>
        }

        if (!localStorage.at || !localStorage.business) {
            return <Redirect from="*" to="/auth/login"/>
        }

        if (this.state.showSalaryEditor === true) {
            window.scrollTo(0, this.tableRef.current.offsetTop);
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showError && <ErrorModal showError={this.state.showError} error={this.state.error}
                                                         toggleErrorModal={() => this.toggleErrorModal()}/>}

                    {this.state.showNotProModal === true && <NotProModal showNotProModal={this.state.showNotProModal}
                                                                         toggleNotProModal={() => this.toggleNotProModal()}/>}

                    <TeacherHeader teacher={this.state.teacher} backToProfile={() => this.goToProfile()}
                                   showClasses={this.showClasses} sendEmail={this.sendEmail}
                                   backToClassId={this.state.backToClassId}
                                   backToClassName={this.state.backToClassName}
                    />

                    {/* Page content */}
                    <Container className="mt--7" fluid>
                        <Row>
                            {this.state.teacher &&
                            <Col className="order-xl-1 mb-5 mb-xl-0" xl="4">
                                <Card className="card-profile shadow">
                                    <Row className="justify-content-center">
                                        <Col className="order-lg-2" lg="3">
                                            <div className="card-profile-image" onClick={this.handleClick.bind(this)}>
                                                <input type="file" id="file" ref={this.fileRef}
                                                       style={{display: "none"}}
                                                       onChange={this.onChangeFile.bind(this)}/>
                                                {/*<div className="App container">*/}

                                                {/*</div>*/}
                                                {!this.state.blob && this.state.teacher && this.state.teacher.photo ? (
                                                    <img
                                                        alt="..."
                                                        style={{objectFit: "cover"}}
                                                        src={this.state.teacher.photo}
                                                    />
                                                ) : (
                                                    <img
                                                        alt="..."
                                                        className="rounded-circle"
                                                        src={require("assets/img/icons/common/generic-person-white.svg").default}
                                                    />
                                                )
                                                }

                                                {this.state.blob &&
                                                <img
                                                    alt="..."
                                                    className="rounded-circle"
                                                    src={this.state.blob}
                                                />
                                                }
                                            </div>
                                            {this.state.photoLoading &&
                                            <RotateCircleLoading color="white"/>
                                            }
                                        </Col>
                                    </Row>
                                    <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                                        <div className="d-flex justify-content-between">
                                            {(this.state.showSalaryEditor === true) &&
                                            <Button
                                                className="mr-4"
                                                color="info"

                                                onClick={e => this.showEditTeacher(e)}
                                                size="sm"
                                            >
                                                {resourceStrings.edit_teacher}
                                            </Button>
                                            }
                                            {/*<Button*/}
                                            {/*  className="float-right"*/}
                                            {/*  color="default"*/}
                                            {/*  */}
                                            {/*  onClick={e => e.preventDefault()}*/}
                                            {/*  size="sm"*/}
                                            {/*>*/}
                                            {/*  Student notes*/}
                                            {/*</Button>*/}
                                        </div>
                                    </CardHeader>
                                    <CardBody className="pt-0 pt-md-4">
                                        <Row>
                                            <div className="col">
                                                <div
                                                    className="card-profile-stats d-flex justify-content-end mt-md-5">
                                                    {/*<Button*/}
                                                    {/*    color="default"*/}
                                                    {/*    onClick={(e) => {*/}
                                                    {/*        this.showTickets(e)*/}
                                                    {/*    }}*/}
                                                    {/*>*/}
                                                    {/*<span*/}
                                                    {/*    className="heading">{this.state.teacher.ticket_count.toString() || "0"}</span>*/}
                                                    {/*    <div className="description">{resourceStrings.tickets}</div>*/}
                                                    {/*</Button>*/}
                                                    {/*<Button*/}
                                                    {/*    color="info"*/}
                                                    {/*    size="sm"*/}
                                                    {/*    outline={true}*/}
                                                    {/*    onClick={(e) => {*/}
                                                    {/*        this.showClasses(e)*/}
                                                    {/*    }}>*/}
                                                    {/*<span*/}
                                                    {/*    className="heading">{this.state.yclasses.length.toString() || "0"}</span>*/}
                                                    {/*    <div className="description">{resourceStrings.classes}</div>*/}
                                                    {/*</Button>*/}
                                                </div>
                                            </div>
                                        </Row>
                                        <div className="text-center">
                                            {this.state.teacher && this.state.teacher.name &&
                                            <h2>
                                                {this.state.teacher.name}
                                            </h2>
                                            }
                                            <div className="h5 mt-4">
                                                {this.state.teacher && this.state.teacher.address ?
                                                    (
                                                        <span> {this.state.teacher.address}</span>
                                                    ) :
                                                    (<span>
                                                    {/*Address is not set*/}
                                                </span>)
                                                }
                                            </div>
                                            <hr className="my-4"/>
                                            {this.renderSalary()}
                                            <ReactTooltip/>
                                            {this.state.teacher && this.state.teacher.note ?
                                                (<p>
                                                    {this.state.teacher.note}
                                                </p>) :
                                                (<p>
                                                    {/*Note is not set*/}
                                                </p>)
                                            }
                                            {/*<a  onClick={e => e.preventDefault()}>*/}
                                            {/*    Show more*/}
                                            {/*</a>*/}
                                        </div>
                                    </CardBody>
                                </Card>

                                {this.state.showSalaryEditor === false &&
                                <Card className="bg-default shadow mt-4">
                                    <CardHeader className="bg-transparent">
                                        <h2 className="text-white mb-0">{resourceStrings.classes} ({this.state.yclasses.length})</h2>
                                    </CardHeader>
                                    <Table
                                        className="align-items-center table-dark table-flush"
                                        responsive
                                    >
                                        <thead className="thead-dark">
                                        <tr>
                                            <th scope="col">{resourceStrings.title}</th>
                                            <th scope="col">{commonStrings.date}</th>
                                            <th scope="col">{studentStrings.students}</th>
                                            <th scope="col"/>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.renderTableData()}
                                        </tbody>
                                    </Table>
                                </Card>
                                }
                            </Col>
                            }

                            {this.state.showSalaryEditor === true &&
                            <Col className="order-xl-1" xl="8">
                                <Card className="bg-secondary shadow">
                                    <CardBody>
                                        <SalaryEditor
                                            teacher={this.state.teacher}
                                            classTypes={this.state.classTypes}
                                            onTeacherPaymentsUpdated={this.onTeacherPaymentsUpdated.bind(this)}
                                            handleNetworkError={this.handleNetworkError}
                                            closeSalaryEditor={this.closeSalaryEditor.bind(this)}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                            }

                            {this.state.showSalaryEditor === false &&
                            // Teacher inputs
                            <Col className="order-xl-1" xl="8">
                                <Card className="bg-secondary shadow">
                                    <CardHeader className="bg-white border-0">
                                        <Row className="align-items-center">
                                            <Col xs="8">
                                                <h3 className="mb-0">{resourceStrings.teacher}</h3>
                                            </Col>
                                            <Col className="text-right" xs="4">
                                                {this.state.profileWasUpdated &&
                                                <Button
                                                    color="default"
                                                    disabled={!this.validationCleared()}
                                                    onClick={e => this.handleSubmit(e)}
                                                    size="sm"
                                                >
                                                    {commonStrings.save}
                                                </Button>
                                                }
                                            </Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <Form onSubmit={this.handleSubmit}>
                                            <h6 className="heading-small text-muted mb-4">
                                                {resourceStrings.teacher_info}
                                            </h6>
                                            <div className="pl-lg-4">
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-name"
                                                            >
                                                                {commonStrings.full_name}
                                                            </label>
                                                            <Input
                                                                className={this.state.validation.name === true ? "form-control-alternative" : "is-invalid"}
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.teacher && this.state.teacher.name ? this.state.teacher.name : this.state.formData.name || ""}
                                                                id="input-name"
                                                                placeholder={commonStrings.full_name}
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <label
                                                            className="form-control-label"
                                                            htmlFor="input-email"
                                                        >
                                                            {commonStrings.email}
                                                        </label>
                                                        <FormGroup>
                                                            <Input
                                                                className={this.state.validation.email === true ? "form-control-alternative" : "is-invalid"}
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.teacher && this.state.teacher.email ? this.state.teacher.email : ''}
                                                                id="input-email"
                                                                placeholder="teacher@sopenmanagerapp.com"
                                                                type="email"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-address"
                                                            >
                                                                {commonStrings.address}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.teacher && this.state.teacher.address ? this.state.teacher.address : ""}
                                                                id="input-address"
                                                                placeholder={commonStrings.address_expl}
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-last-name"
                                                            >
                                                                {commonStrings.phone}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                id="input-phone"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.teacher && this.state.teacher.phone ? this.state.teacher.phone : ""}
                                                                placeholder={commonStrings.phone}
                                                                type="tel"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-id-number"
                                                            >
                                                                {commonStrings.id_number}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.teacher && this.state.teacher.dni ? this.state.teacher.dni : ""}
                                                                id="input-id-number"
                                                                placeholder="XXX-00000"
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-pm"
                                                            >
                                                                {commonStrings.payment_method}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                id="input-pm"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.teacher && this.state.teacher.pm ? this.state.teacher.pm : ""}
                                                                placeholder={commonStrings.payment_method_expl}
                                                                type="tel"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>

                                            <hr className="my-4"/>
                                            {/* Bio */}
                                            <div className="pl-lg-4">
                                                <FormGroup>
                                                    <label className="form-control-label"
                                                           htmlFor="input-bio">{commonStrings.bio}</label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        id="input-bio"
                                                        placeholder={commonStrings.bio_expl}
                                                        onChange={this.handleChange}
                                                        defaultValue={this.state.teacher && this.state.teacher.bio ? this.state.teacher.bio : ''}
                                                        rows="4"
                                                        type="textarea"
                                                    />
                                                </FormGroup>
                                            </div>
                                            <hr className="my-4"/>
                                            {/* Birthday */}
                                            <h6 className="heading-small text-muted mb-4">{commonStrings.birthday}</h6>
                                            <div className="pl-lg-4">
                                                <Row>
                                                    <Col lg="3">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-id-number"
                                                            >
                                                                {commonStrings.day}
                                                            </label>
                                                            <Input
                                                                className={this.state.validation.day === true ? "form-control-alternative" : "is-invalid"}
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.teacher && this.state.teacher.bd ? this.getBdDay() : ""}
                                                                id="input-bd-day"
                                                                placeholder=""
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="9">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                            >
                                                                {commonStrings.month}
                                                            </label>
                                                            <Select
                                                                className="form-control-alternative"
                                                                value={this.getBdMonth()}
                                                                onChange={this.handleMonthSelected}
                                                                options={constants.months}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                            {/* Note */}
                                            <h6 className="heading-small text-muted mb-4">Notes</h6>
                                            <div className="pl-lg-4">
                                                <FormGroup>
                                                    <label>{commonStrings.note}</label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        id="input-note"
                                                        placeholder={commonStrings.note_expl}
                                                        onChange={this.handleChange}
                                                        defaultValue={this.state.teacher && this.state.teacher.note ? this.state.teacher.note : ''}
                                                        rows="4"
                                                        type="textarea"
                                                    />
                                                </FormGroup>
                                            </div>

                                            <div>
                                                <FormGroup>
                                                    <div className="custom-control custom-checkbox mt-4"
                                                    >
                                                        <input
                                                            className="custom-control-input"
                                                            id="input-public-cb"
                                                            type="checkbox"
                                                            onChange={this.handleChange}
                                                            checked={this.state.teacher && this.state.teacher.public === true}
                                                        />
                                                        <label className="custom-control-label"
                                                               htmlFor="input-public-cb">
                                                            {resourceStrings.public}
                                                        </label>
                                                    </div>
                                                </FormGroup>
                                                <small className="mt--4">
                                                    <i>{resourceStrings.public_teacher_expl}</i>
                                                </small>
                                            </div>

                                        </Form>
                                        <Row className="align-items-end">
                                            <Col className="text-right" xs="12">
                                                {this.state.profileWasUpdated &&
                                                <Button
                                                    color="default"
                                                    disabled={!this.validationCleared()}
                                                    onClick={e => this.handleSubmit(e)}
                                                    size="lg"
                                                >
                                                    {commonStrings.save}
                                                </Button>
                                                }
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            }
                            <div ref={this.tableRef}/>
                        </Row>
                    </Container>
                </>
            </LoadingOverlay>
        );
    }

    handleValidation() {
        this.validateName();
        this.validateEmail();
    }

    validateName() {
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                name: this.state.formData.name.length > 1,
            }
        }));
    }

    validateEmail() {
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                email: (!this.state.formData.email) || (this.state.formData.email.length === 0) || (this.state.formData.email.includes("@") && this.state.formData.email.includes(".")),
            }
        }));
    }

    validateDay(day) {
        const d = parseInt(day);
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                day: d >= 0 && d <= 31,
            }
        }));
    }

    validationCleared() {
        return Object.values(this.state.validation).every(item => item)
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        studentStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    goToClass(id) {
        this.setState({goToClass: true, goToClassId: id})
    }

    toggleDeletionModal = state => {
        this.setState({
            showDeletionModal: !this.state.showDeletionModal
        });
    };

    renderDeletionModal() {
        return (
            <Modal
                className="modal-dialog-centered modal-danger"
                contentClassName="bg-gradient-danger"
                isOpen={this.state.showDeletionModal}
                toggle={() => this.toggleDeletionModal("notificationModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {/*Your attention is required*/}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleDeletionModal("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="py-3 text-center">
                        <MdDelete size="50px"/>
                        {alertStrings.confirmation_alert_title}
                        <p>
                            {alertStrings.confirm_delete_ticket}
                        </p>
                    </div>
                </div>
                <div className="modal-footer">
                    <Col className="text-center">
                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={this.deleteTicket}>
                            {alertStrings.yes}
                        </Button>

                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={this.toggleDeletionModal}>
                            {alertStrings.no}
                        </Button>

                    </Col>
                </div>
            </Modal>
        )
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false, photoLoading: false})
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    toggleNotProModal() {
        this.setState({showNotProModal: false})
    }

    goToProfile() {
        this.setState({backToProfile: true})
    }

    getTeacherSalary() {
        this.setState({
            isSalaryLoading: true,
        });

        ResourceApiService.teacherSalary(this.state.teacher ? this.state.teacher.id : this.state.teacherId, dateHelpers.databaseDate(this.state.selectedDate))
            .then(res => {
                this.setState({
                    salaryForSelectedMonth: res.salary,
                    isSalaryLoading: false,
                });
            })
            .catch((e) => {
                this.setState({
                    isSalaryLoading: false,
                });
                this.handleNetworkError(e)
            });
    }

    onTeacherPaymentsUpdated() {
        this.getTeacherSalary()
    }

    showNextMonth(e) {
        if (e) e.preventDefault();

        const d = this.state.selectedDate;
        const newDate = dateHelpers.addMonth(d, 1);
        this.setState({selectedDate: newDate});
        this.getTeacherSalary();
        this.getTeacherClasses();
    }

    showPrevMonth(e) {
        if (e) e.preventDefault();

        const d = this.state.selectedDate;
        const newDate = dateHelpers.addMonth(d, -1);
        this.setState({selectedDate: newDate});
        this.getTeacherSalary();
        this.getTeacherClasses();
    }

    editSalary(e) {
        if (subscriptionHelpers.hasSubscription()) {
            e.preventDefault();
            this.requestSalaryEditor()
        }
        else {
            this.setState({showNotProModal: true})
        }
    }

    nextMonthName() {
        return "next"
    }

    prevMonthName() {
        return "prev"
    }

    formatSalary() {
        const s = this.state.salaryForSelectedMonth || 0;
        const formatted = numberHelpers.formatPrice(s / 100)
        const cur = businessHelper.currency();
        const month = dateHelpers.monthYear(this.state.selectedDate || new Date());
        return month + ": " + cur + " " + formatted
    }

    renderSalary() {
        if (!this.state.isTeacherSession)
            return (
                <>
                    <label
                        className="form-control-label"
                        htmlFor="input-name"
                    >
                        {commonStrings.salary}
                    </label>
                    <Col lg="12">
                        <Row className="align-content-center">
                            <Col>
                        <span>
                            <Button
                                color="default"
                                style={{width: "100%"}}
                                className="btn-facebook"
                                data-type="info"
                                data-tip={commonStrings.click_to_edit}
                                onClick={e => this.editSalary(e)}
                                size="lg"
                            >
                                {this.state.isSalaryLoading ?
                                    (<RotateCircleLoading color="white"/>) : (
                                        <div className="text-capitalize">{this.formatSalary()}</div>)} <ProBadge color={"white"}/>
                            </Button>
                        </span>
                            </Col>
                        </Row>


                        <Row className="align-content-center" style={{marginTop: 10}}>
                            <Col lg="6" className="text-left">
                                <Button color="secondary" outline type="button" onClick={e => this.showPrevMonth()}>
                                    {commonStrings.prev}
                                </Button>
                            </Col>
                            <Col lg="6" className="text-right text-darker">
                                <Button color="secondary" outline type="button" onClick={e => this.showNextMonth()}>
                                    {commonStrings.next}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </>
            );
    }

    getTeacherClasses() {
        ResourceApiService.teacherClasses(this.state.teacher ? this.state.teacher.id : this.state.teacherId, dateHelpers.databaseDate(this.state.selectedDate))
            .then(res => {
                this.setState({
                    yclasses: res,
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    getClassTypes() {
        this.setState({isLoading: true});

        ResourceApiService.classTypes()
            .then(res => {
                this.setState({
                    classTypes: res,
                    isLoading: false
                });

                this.requestSalaryEditor()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    closeSalaryEditor(e) {
        e.preventDefault();
        this.setState({showSalaryEditor: false})
    }

    requestSalaryEditor() {
        if (this.state.classTypes === null) this.getClassTypes();
        else this.setState({showSalaryEditor: true})
    }
}

export default Teacher;
